var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5411 6.88094C10.4303 6.88094 10.3195 6.83427 10.232 6.73427L7.00031 3.04094L3.76865 6.73427C3.59948 6.9276 3.31948 6.9276 3.15031 6.73427C2.98115 6.54094 2.98115 6.22094 3.15031 6.0276L6.69115 1.98094C6.86031 1.7876 7.14031 1.7876 7.30948 1.98094L10.8503 6.0276C11.0195 6.22094 11.0195 6.54094 10.8503 6.73427C10.7686 6.83427 10.652 6.88094 10.5411 6.88094Z",
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 14.1673C6.76083 14.1673 6.5625 13.9406 6.5625 13.6673V2.44727C6.5625 2.17393 6.76083 1.94727 7 1.94727C7.23917 1.94727 7.4375 2.17393 7.4375 2.44727V13.6673C7.4375 13.9406 7.23917 14.1673 7 14.1673Z",
    fill: "#29B719"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrup);
export default __webpack_public_path__ + "static/media/arrup.d7d79937c82fdcaba9b56ba4659ec926.svg";
export { ForwardRef as ReactComponent };